import React from "react";
import { Row, Col, Card, Navbar } from "react-bootstrap";
import bgShape from "assets/img/illustrations/bg-shape.png";
import shape1 from "assets/img/illustrations/shape-1.png";
import AppCard from "components/common/AppCard";
import Section from "components/common/Section";
import paths from "routes/paths";
import ProfileDropdown from "components/navbar/top/ProfileDropdown";
import { Nav } from "react-bootstrap";
import ProtectedRoute from "components/common/pyramid/ProtectedRoute";
import { useAuth } from "hooks/useAuth";

const SolutionsShowcase = () => {
  const { hasModule, isLoading } = useAuth();

  return (
    <ProtectedRoute>
      <>
        {/* Full-width section with padding 0 */}
        <Section fluid className="py-0">
          <Row className="g-0 min-vh-100 flex-center">
            {/* Main column with ample space for content */}
            <Col lg={9} xxl={7} className="py-3 position-relative">
              {/* Background images */}
              <img
                className="bg-auth-circle-shape"
                src={bgShape}
                alt=""
                width="250"
              />
              <img
                className="bg-auth-circle-shape-2"
                src={shape1}
                alt=""
                width="150"
              />

              {/* Main card containing the content */}
              <Card className="overflow-hidden z-1">
                <Card.Body className="p-0">
                  {/* Navbar with profile dropdown */}
                  <Navbar className="navbar navbar-nav-icons ms-auto text-white text-center bg-card-gradient">
                    <Nav
                      className="position-absolute top-0 end-0 p-4"
                      style={{ zIndex: 1050 }}
                      as="ul"
                    >
                      {/* Profile dropdown in navbar */}
                      <ProfileDropdown />
                    </Nav>
                    <div className="position-relative p-4 pt-md-4 pb-md-4">
                      <div
                        className="z-1 position-relative"
                        data-bs-theme="light"
                      >
                        <span className="mb-4 font-sans-serif fw-bolder fs-5 d-inline-block">
                          Pyramid
                        </span>
                        <p className="opacity-75 text-white">
                          Focused on the digital ecosystem, we drive value
                          through innovation, helping clients transition to
                          efficient, tech-driven models.
                        </p>
                      </div>
                    </div>
                  </Navbar>

                  {/* Main content of the section */}
                  <div className="position-relative p-4 pt-md-4 pb-md-4">
                    {isLoading ? (
                      <div className="text-center py-5">
                        <div
                          className="spinner-border text-primary"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    ) : (
                      <Row className="g-3 justify-content-center">
                        {hasModule("Osiris") && (
                          <AppCard
                            to={paths.osirisDashboard}
                            logoName="Osiris"
                            text="ECL calculation solution fully compliant with regulatory frameworks, enabling computation and visualization of credit risk and accounting impacts."
                          />
                        )}

                        {hasModule("Horus") && (
                          <AppCard
                            to={paths.horusDashboard}
                            logoName="Horus"
                            text="Amortization calculation solution compliant with regulatory frameworks, providing advanced computation and clear visualization of accounting impacts."
                          />
                        )}
                      </Row>
                    )}
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Section>
      </>
    </ProtectedRoute>
  );
};

export default SolutionsShowcase;
